












import {
  computed,
  ComputedRef,
  defineComponent,
  ref,
  Ref,
} from '@vue/composition-api';
import { MobileAppIconProps } from './types';
import { useIconSizeObserver } from '../../hooks/useIconSizeObserver';

interface MobileAppIconBinding {
  iconElement: Ref<HTMLDivElement | undefined>;
  iconSquareStyle: ComputedRef<CSSStyleDeclaration>;
  iconStyle: ComputedRef<CSSStyleDeclaration>;
}

export default defineComponent<MobileAppIconProps, MobileAppIconBinding>({
  name: 'MobileAppIcon',
  props: {
    icon: {
      type: Array,
      default: () => [],
    },
    iconRatio: {
      type: Number,
      default: 0.7,
    },
  },
  setup(props) {
    const iconElement = ref<HTMLDivElement>();
    const iconSize = useIconSizeObserver(iconElement);

    return {
      iconElement,
      iconSquareStyle: computed<CSSStyleDeclaration>(() => ({
        height: `${iconSize.value}px`,
      } as CSSStyleDeclaration)),
      iconStyle: computed<CSSStyleDeclaration>(() => ({
        width: `${(props.iconRatio || 1) * 100}%`,
        height: `${(props.iconRatio || 1) * 100}%`,
      } as CSSStyleDeclaration)),
    };
  },
});
